import React from "react";
import ModuleContent from "./ModuleContent";

export const ExpandedModule = ({ title, onClose, onNavigate }) => {
  // Array of all expanded module content. Includes expanded asset, list item names, and paths.
  // 'imgSrc' is for the alternate (sss-blue) module icons.
  const expandedModuleContent = {
    "Call Center": {
      imgSrc: "assets/dashboard/alt-module-icon-call-center.png",
      items: [
        { name: "Call Center List", path: "/call-center/callcenterlist" },
        {
          name: "Open Items List",
          path: null,
          showDivider: true,
          disabled: true,
        },
        {
          name: "Call Center",
          path: "/call-center/AdvancedCallCenterDashboard",
        },
        {
          name: "Trouble Call Entry",
          path: "/call-center/troublecallentry",
          disabled: true,
        },
        {
          name: "Dispatch Entry",
          path: "/call-center/dispatch-entry",
          showDivider: true,
        },
        { name: "History", path: "/call-center/history" },
        { name: "Trouble Calls", path: null },
        { name: "Dispatches", path: null, showDivider: true, disabled: true },
        { name: "Employee Log", path: "/call-center/employeelog" },
        {
          name: "Time Ticket Entry and Edit",
          path: "/call-center/timeticket-entry-and-edit",
        },
        {
          name: "Action Items",
          path: "/call-center/action-items",
          disabled: true,
        },
        {
          name: "Survey Request Entry",
          path: "/call-center/survey-request-entry",
        },
        {
          name: "Dispatch Hours Building Review",
          path: "/call-center/dispatch-hours",
        },
        { name: "Dispatch Reporter", path: null },
      ],
    },
    "Maintenance Contracts": {
      imgSrc: "assets/dashboard/alt-module-icon-maintenance.png",
      items: [
        {
          name: "Maintenance Contracts List",
          path: "/maintenance/maintenanceContractsList",
        },
        {
          name: "Maintenance Contracts Dashboard",
          path: "/maintenance/maintenance-dashboard",
          showDivider: true,
        },
        {
          name: "Parent Contract Set Up",
          path: "/maintenance/parent-contract-setup",
        },
        { name: "Maintenance Contracts Markups", path: null, disabled: true },
        { name: "Maintenance Contracts Holds", path: null, disabled: true },
        { name: "Maintenance Invoicing", path: null, disabled: true },
        {
          name: "Invoicing Email Set Up",
          path: "/maintenance/invoicing-email-setup",
          showDivider: true,
        },
        {
          name: " Maintenance Route Planning",
          path: "/maintenance/maintenance-route-planning",
        },
        { name: "Route Summary", path: "/maintenance/routesummary" },
        { name: "Route Summary Log", path: null, disabled: true },
        { name: "Route Analysis", path: "/maintenance/routeanalysis" },
        {
          name: "Account Analysis",
          path: null,
          showDivider: true,
          disabled: true,
        },
        {
          name: "Scheduled Maintenance",
          path: "/maintenance/schedule-maintenance",
        },
      ],
    },
    "Inspections & Violations": {
      imgSrc: "assets/dashboard/alt-module-icon-inspections.png",
      items: [
        {
          name: "Violations List",
          path: "/inspections-violations/violations-lists",
        },
        {
          name: "Inspections List",
          path: "/inspections-violations/inspections-list",
        },
        {
          name: "Inspections Devices List",
          path: "/inspections-violations/inspections-devices-list",
        },
        {
          name: "Inspections Map View",
          path: "/inspections-violations/inspections-list-map-view",
        },
        {
          name: "Test Due",
          path: "/inspections-violations/tests-due",
          showDivider: true,
        },
        {
          name: "DOB Now Connect",
          path: "/inspections-violations/dobnowconnect",
        },
        {
          name: "DOB Violation Tracking",
          path: "/inspections-violations/dob-violation-tracking",
          showDivider: true,
        },
        {
          name: "Violations Entry",
          path: "/inspections-violations/violations-entry",
        },
        {
          name: "Inspections Emailer",
          path: "/inspections-violations/inspections-email-notifications",
        },
        { name: "Agencies List", path: "/inspections-violations/agency" },
        {
          name: "Service Companies List",
          path: "/inspections-violations/service-companies",
        },
        {
          name: "Account Pricing List",
          path: "/inspections-violations/account-pricing",
        },
        // {
        //   name: "Default Deficiencies",
        //   path: "/inspections-violations/default-deficiencies",
        // },
      ],
    },
    "Invoicing": {
      imgSrc: "assets/dashboard/alt-module-icon-invoices.png",
      items: [
        {
          name: "Invoice List",
          path: "/invoicing/invoice-list",
          showDivider: true,
        },
        { name: "Invoice Wizard", path: "/invoicing/invoice-wizard" },
        { name: "Invoice Entry", path: "/invoicing/invoice-entry-page" },
        { name: "Invoice Print and Post", path: null, disabled: true },
        {
          name: "Auto Invoicing",
          path: null,
          showDivider: true,
          disabled: true,
        },
        {
          name: "Invoice Finance Changes",
          path: "/invoicing/invoice-finance-charges",
        },
        //{ name: "Invoice Emailer", path: null, disabled: true },
        //{ name: "Invoice Viewer", path: null, disabled: true },
      ],
    },
    "Proposals & Jobs": {
      imgSrc: "assets/dashboard/alt-module-icon-proposals.png",
      items: [
        {
          name: "Proposals & Jobs Dashboard",
          path: "/proposals-and-jobs/proposals-and-jobs-list",
        },
        {
          name: "Job Cost List",
          path: null,
          showDivider: true,
          disabled: true,
        },
        { name: "Proposal System Setup", path: null, disabled: true },
        //{ name: "Bids Entry and Edit", path: null, disabled: true },
        { name: "Proposal Log", path: null, disabled: true },
        { name: "Accepted Proposals/Job", path: null, disabled: true },
        {
          name: "Proposal Templates",
          path: null,
          showDivider: true,
          disabled: true,
        },
        { name: "Proposal Items", path: null, disabled: true },
        { name: "Item List", path: null, disabled: true },
        {
          name: "Item Detail Entry",
          path: null,
          showDivider: true,
          disabled: true,
        },
        { name: "Job Schedule", path: null, disabled: true },
        {
          name: "Proposal Wizard",
          path: "/proposals-and-jobs/proposal-wizard",
        },
        {
          name: "Job Billing Review - Progress Billing",
          path: null,
          disabled: true,
        },
        { name: "Jobs Monthly Earned Revenue", path: null, disabled: true },
      ],
    },
    "Setup": {
      imgSrc: "assets/dashboard/alt-module-icon-setup.png",
      items: [
        { name: "Management Companies", path: "/setup/managementcompanies" },
        { name: "Customers", path: "/setup/customers" },
        { name: "Buildings", path: "/setup/buildings" },
        { name: "Devices", path: "/setup/devicelist" },
        { name: "Rolodex", path: "/setup/rolodex", showDivider: true },
        { name: "Sales Person", path: "/setup/salesperson" },
        { name: "Payment Terms", path: "/setup/paymentterms" },
        { name: "Tax Details", path: "/setup/taxdetails" },
        //{ name: "System Data", path: null, disabled: true },
        //{ name: "Company Setup", path: null, disabled: true },
        { name: "Company Defaults", path: "/setup/company-defaults" },
        { name: "Company Mass Emailer", path: null, disabled: true },
        { name: "Tax Authorities", path: null, disabled: true },
        { name: "Inspectors", path: "/setup/inspectorslist" },
        { name: "Employees", path: "/setup/employees" },
        { name: "Billing and Costing Rates", path: null, disabled: true },
        { name: "Route Set Up", path: null, disabled: true },
        //{ name: "OnBoarding", path: "/setup/dataonboarding" },
      ],
    },
    "Reports": {
      imgSrc: "assets/dashboard/alt-module-icon-reports.png",
      items: [
        //{ name: "Email System Reports", path: null },
        //{ name: "Report Emailer", path: null },
        //{ name: "GL Reporting Tool", path: null },
        {
          name: "Dispatch Labor Analysis",
          path: null,
          showDivider: true,
        },
        { name: "Sales Summary", path: null },
        //{ name: "Use Tax Calculator", path: null },
        //{ name: "Building Sites", path: null },
        //{ name: "Calls and Dispatching", path: null },
        //{ name: "Cash Receipts", path: null },
        //{ name: "Customers", path: null },
        //{ name: "Maintenance Contracts", path: null },
        //{ name: "Management Reports", path: null },
        { name: "Proposals", path: null },
        { name: "System Reports", path: null },
        { name: "Route Mapper", path: "/reports/route-mapper" },
      ],
    },
    "Admin": {
      imgSrc: "assets/dashboard/alt-module-icon-setup.png",
      items: [{ name: "User Security", path: "/user-security" }],
    },
  };

  return (
    <div className="border border-1 rounded-md border-sss-blue mr-12 mb-8">
      <div className="flex justify-end mr-2 mt-2">
        <button onClick={onClose} className="w-4 h-4 mr-2">
          <img src="assets/dashboard/module-icon-min.png" alt="" />
        </button>
        <button onClick={onClose} className="w-4 h-4">
          <img src="assets/dashboard/module-icon-open.png" alt="" />
        </button>
      </div>
      <div className="pl-5 pr-10">
        <div className="mx-auto my-4">
          {expandedModuleContent[title] && (
            <ModuleContent
              title={title}
              imgSrc={expandedModuleContent[title].imgSrc}
              items={expandedModuleContent[title].items}
            />
          )}
        </div>
      </div>
    </div>
  );
};
